import React from 'react';
export function ClaimCreatedCorporateTemplate() {
  return <div style={{
    fontFamily: 'Arial, sans-serif',
    maxWidth: '600px',
    margin: '0 auto'
  }} data-id="element-161">
      {/* Header with logo */}
      <div style={{
      textAlign: 'center',
      padding: '32px 0'
    }} data-id="element-162">
        <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/hnodgoqduyba7n8dlqxg6c/d4d40573-a6d5-4127-bafb-e288840a0b5f/AISCO_WORKSPACE_MARCA_POSITIVO.svg" alt="Aisco Workspace" style={{
        height: '40px',
        display: 'inline-block'
      }} data-id="element-163" />
      </div>

      {/* Main content */}
      <div style={{
      backgroundColor: '#ffffff',
      padding: '40px 32px'
    }} data-id="element-164">
        <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '24px'
      }} data-id="element-165">
          <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          margin: '0'
        }} data-id="element-166">
            New dealer claim
          </h1>
          <span style={{
          fontSize: '13px',
          fontWeight: '600',
          color: '#2563eb',
          backgroundColor: '#eff6ff',
          padding: '4px 12px',
          borderRadius: '4px',
          border: '1px solid #bfdbfe'
        }} data-id="element-167">
            {2025240691}
          </span>
        </div>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '8px'
      }} data-id="element-168">
          Hello <strong data-id="element-169">Regis Simier</strong>,
        </p>

        <p style={{
        fontSize: '16px',
        color: '#4b5563',
        lineHeight: '1.6',
        marginBottom: '32px'
      }} data-id="element-170">
          A new claim has been created by <strong data-id="element-171">CANAGRO EXPORTS INC.</strong>{' '}
          and assigned to <strong data-id="element-172">Aisco Europe</strong> for review and
          processing.
        </p>

        {/* Claim Details */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }} data-id="element-173">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-174">
            Claim Information
          </h3>
          <div style={{
          display: 'grid',
          gap: '12px'
        }} data-id="element-175">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-176">
              <span style={{
              color: '#6b7280'
            }} data-id="element-177">
                Report Date:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-178">
                January 15, 2025
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-179">
              <span style={{
              color: '#6b7280'
            }} data-id="element-180">
                Business Unit:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-181">
                Aisco Europe
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-182">
              <span style={{
              color: '#6b7280'
            }} data-id="element-183">
                Claim Type:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-184">
                Technical Issue
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-185">
              <span style={{
              color: '#6b7280'
            }} data-id="element-186">
                Dealer:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-187">
                CANAGRO EXPORTS INC.
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-188">
              <span style={{
              color: '#6b7280'
            }} data-id="element-189">
                Customer:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-190">
                Dimitri Yakolev
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-191">
              <span style={{
              color: '#6b7280'
            }} data-id="element-192">
                Country:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-193">
                Canada
              </span>
            </div>
          </div>
        </div>

        {/* Machine Details */}
        <div style={{
        backgroundColor: '#f9fafb',
        padding: '20px',
        borderRadius: '8px',
        border: '1px solid #e5e7eb',
        marginBottom: '24px'
      }} data-id="element-194">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#6b7280',
          marginTop: '0',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-195">
            Machine Details
          </h3>
          <div style={{
          display: 'grid',
          gap: '12px'
        }} data-id="element-196">
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-197">
              <span style={{
              color: '#6b7280'
            }} data-id="element-198">
                Serial Number:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-199">
                002457898987
              </span>
            </div>
            <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-200">
              <span style={{
              color: '#6b7280'
            }} data-id="element-201">
                Installation Date:
              </span>
              <span style={{
              color: '#1f2937',
              fontWeight: '500'
            }} data-id="element-202">
                May 17, 2025
              </span>
            </div>
          </div>
        </div>

        {/* Problem Description */}
        <div style={{
        backgroundColor: '#eff6ff',
        padding: '20px',
        borderRadius: '8px',
        borderLeft: '4px solid #2563eb',
        marginBottom: '32px'
      }} data-id="element-203">
          <h3 style={{
          fontSize: '14px',
          fontWeight: '600',
          color: '#1e40af',
          marginTop: '0',
          marginBottom: '12px',
          textTransform: 'uppercase',
          letterSpacing: '0.5px'
        }} data-id="element-204">
            Problem Description
          </h3>
          <p style={{
          margin: '0',
          color: '#1e40af',
          fontSize: '14px',
          lineHeight: '1.6'
        }} data-id="element-205">
            Fallo de tarjeta SIM en Icontrol pump por cantidad de dias de
            inactividad. pedimos que nos envien tarjetas SIM de repuesto (en lo
            posible de "Telefonica" ya que es la compania que mejor cobertura
            ofrece en la zona.
          </p>
        </div>

        {/* CTA Button */}
        <div style={{
        textAlign: 'center',
        margin: '32px 0'
      }} data-id="element-206">
          <a href="#" style={{
          display: 'inline-block',
          backgroundColor: '#2563eb',
          color: '#ffffff',
          padding: '14px 32px',
          borderRadius: '8px',
          textDecoration: 'none',
          fontSize: '16px',
          fontWeight: '600'
        }} data-id="element-207">
            Review and process claim
          </a>
        </div>

        <p style={{
        fontSize: '14px',
        color: '#6b7280',
        lineHeight: '1.6',
        marginTop: '32px',
        marginBottom: '0',
        textAlign: 'center'
      }} data-id="element-208">
          Please review this claim and take appropriate action through Aisco
          Workspace.
        </p>
      </div>

      {/* Footer */}
      <div style={{
      backgroundColor: '#f9fafb',
      padding: '24px 32px',
      borderTop: '1px solid #e5e7eb',
      textAlign: 'center'
    }} data-id="element-209">
        <p style={{
        fontSize: '12px',
        color: '#6b7280',
        lineHeight: '1.5',
        margin: '0'
      }} data-id="element-210">
          Aisco Europe S.A.U • Calle Playa de Riazor 22, 28042
          <br data-id="element-211" />
          Madrid, Spain
        </p>
      </div>
    </div>;
}